module.exports = __webpack_public_path__ + "static/media/icons_Bilan Sclérose en Plaques.2d5c76f6.svg";